import { SourceSystem } from '@/api/doc/source-system';
import { Button } from '@/components/ui/button';
import { ColumnDef } from '@tanstack/react-table';
import { format } from 'date-fns';
import { ArrowUpDown } from 'lucide-react';

import { UpdateSourceSystem } from './sheet-update';

export const columns: ColumnDef<SourceSystem>[] = [
	{
		accessorKey: 'id',
		header: ({ column }) => (
			<Button
				variant="ghost"
				onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
			>
				Id
				<ArrowUpDown />
			</Button>
		),
		cell: ({ row }) => <div className="font-medium">{row.original.id}</div>,
	},
	{
		accessorKey: 'name',
		header: ({ column }) => (
			<Button
				variant="ghost"
				onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
			>
				Name
				<ArrowUpDown />
			</Button>
		),
		cell: ({ row }) => <div className="font-medium">{row.original.name}</div>,
	},
	{
		accessorKey: 'slug',
		header: ({ column }) => (
			<Button
				variant="ghost"
				onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
			>
				Slug
				<ArrowUpDown />
			</Button>
		),
		cell: ({ row }) => <div className="font-medium">{row.original.slug}</div>,
	},
	{
		accessorKey: 'deletedOn',
		header: ({ column }) => (
			<Button
				variant="ghost"
				onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
			>
				Deleted On
				<ArrowUpDown />
			</Button>
		),
		cell: ({ row }) => {
			return (
				<div>
					{row.original.deletedOn ? format(row.original.deletedOn, 'P') : '---'}
				</div>
			);
		},
	},
	{
		id: 'edit',
		cell: ({ row }) => <UpdateSourceSystem sourceSystem={row.original} />,
	},
];
